module.exports = __webpack_public_path__ + "assets/img/bg-content-large.2e63a659.png";